import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  Typography
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import AutofillV3 from "components/Wrappers/materialUIWrappers/components/AutofillV3";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import DayMonth from "components/Wrappers/materialUIWrappers/components/DayMonth";

import { GetUserToken } from "helpers/UserHelper";
import { OccupationSearch } from "queries/OccupationSearch";
import React from "react";
import { Query } from "react-apollo";
import { Field, reduxForm } from "redux-form";
import { get } from "lodash";
import store from "store";
import { monthDayValid, isEmptyOrSpaces } from "helpers/ValidationHelpers";
import { validateDateRange } from "helpers/DateHelpers";
import { showSnack } from "reducers/NotificationReducer";

const charMin3 = value =>
  !value
    ? undefined
    : value.length > 2
    ? undefined
    : "Must be at least 3 characters";

const FromToGrid = props => (
  <GridItem xs={12} sm={6} md={6} style={{ marginBottom: "25px" }}>
    <Grid container style={{ border: "1px solid #ccc", position: "relative" }}>
      <Typography className="floatyLabelTopLeft">{props.label}</Typography>
      <Grid
        item
        xs={6}
        sm={6}
        md={6}
        style={{ marginTop: "20px", padding: "10px" }}
      >
        {props.from}
      </Grid>

      <Grid
        item
        xs={6}
        sm={6}
        md={6}
        style={{ marginTop: "20px", padding: "10px" }}
      >
        {props.to}
      </Grid>
    </Grid>
  </GridItem>
);

class SearchDialog extends React.Component {
  state = {
    checkValidation: false,
    loadingSubmit: false,
    occupation: "",
    trySubmit: false
  };

  birthdayToValid = value => {
    if (isEmptyOrSpaces(value)) {
      return undefined;
    }

    let birthdayFrom = get(
      store.getState().form.advancedSearch,
      "values.birthdayFrom",
      null
    );

    if (!birthdayFrom || birthdayFrom.length !== 5) return undefined;

    if (!validateDateRange(`${birthdayFrom}/2018`, `${value}/2018`)) {
      return "Must be later than from date";
    }

    return undefined;
  };

  anneversaryToValid = value => {
    if (isEmptyOrSpaces(value)) {
      return undefined;
    }

    let anneversaryFrom = get(
      store.getState().form.advancedSearch,
      "values.anneversaryFrom",
      null
    );

    if (!anneversaryFrom || anneversaryFrom.length !== 5) return undefined;

    if (!validateDateRange(`${anneversaryFrom}/2018`, `${value}/2018`)) {
      return "Must be later than from date";
    }

    return undefined;
  };

  incomeToValid = value => {
    if (isEmptyOrSpaces(value)) {
      return undefined;
    }

    let incomeMin = get(
      store.getState().form.advancedSearch,
      "values.incomeMin",
      null
    );

    if (!incomeMin) return undefined;

    if (incomeMin > value) {
      return "Must be greater than minimum";
    }

    return undefined;
  };

  ageMaxValid = value => {
    if (isEmptyOrSpaces(value)) {
      return undefined;
    }

    let ageMin = get(
      store.getState().form.advancedSearch,
      "values.ageMin",
      null
    );

    if (!ageMin) return undefined;

    if (ageMin > value) {
      return "Must be greater than minimum";
    }

    return undefined;
  };

  onSubmit = () => {
    this.setState({ trySubmit: true });
    if (store.getState().form.advancedSearch.syncErrors) {
      store.dispatch(
        showSnack({
          message: "Invalid Information",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      this.forceUpdate();
      return;
    }

    let search = get(store.getState().form.advancedSearch, "values", null);
    if (!search) return;

    let searchString = "";

    searchString += !isEmptyOrSpaces(search.occupation)
      ? `occupation=${search.occupation}`
      : "";

    searchString += !isEmptyOrSpaces(this.dropDownValidate(search.title))
      ? `&title=${search.title}`
      : "";

    searchString += !isEmptyOrSpaces(this.dropDownValidate(search.language))
      ? `&language=${search.language}`
      : "";

    searchString += !isEmptyOrSpaces(this.dropDownValidate(search.smoker))
      ? `&smoker=${search.smoker}`
      : "";

    searchString += !isEmptyOrSpaces(search.birthdayFrom)
      ? `&birthdayFrom=${search.birthdayFrom}`
      : "";
    searchString += !isEmptyOrSpaces(search.birthdayTo)
      ? `&birthdayTo=${search.birthdayTo}`
      : "";

    searchString += !isEmptyOrSpaces(search.anneversaryFrom)
      ? `&anneversaryFrom=${search.anneversaryFrom}`
      : "";
    searchString += !isEmptyOrSpaces(search.anneversaryTo)
      ? `&anneversaryTo=${search.anneversaryTo}`
      : "";

    searchString += !isEmptyOrSpaces(search.incomeMin)
      ? `&incomeFrom=${search.incomeMin}`
      : "";
    searchString += !isEmptyOrSpaces(search.incomeMax)
      ? `&incomeTo=${search.incomeMax}`
      : "";

    searchString += !isEmptyOrSpaces(search.ageMin)
      ? `&ageFrom=${search.ageMin}`
      : "";
    searchString += !isEmptyOrSpaces(search.ageMax)
      ? `&ageTo=${search.ageMax}`
      : "";

    console.log("searchString:", searchString);

    this.props.history.push({
      pathname: "/app/advancedsearch",
      search: searchString
    });
  };

  dropDownValidate = value => {
    return value && value !== "validationError";
  };

  occupationTextChanged = (event, refetch) => {
    if (event && event.target) {
      this.setState({
        occupation: event.target.value
      });
      refetch();
    }
  };

  occupationSelected = (displayText, id, refetch) => {
    this.setState({
      occupation: displayText
    });
    refetch();
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.closeDialog}
        className="centerFixedDialog"
      >
        {this.state.loadingSubmit ? null : (
          <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
            Advanced Search
          </DialogTitle>
        )}
        <DialogContent style={{ paddingTop: "20px" }}>
          {this.state.loadingSubmit ? (
            <div style={{ textAlign: "center" }}>
              <Typography style={{ marginBottom: "15px" }}>
                Saving...
              </Typography>
              <CircularProgress size={25} />
            </div>
          ) : (
            <Grid container>
              <Query
                query={OccupationSearch}
                variables={{
                  search:
                    this.state.occupation.length > 2
                      ? this.state.occupation
                      : "",
                  token: GetUserToken()
                }}
                fetchPolicy="network-only"
              >
                {({ loading, error, data, refetch }) => {
                  return (
                    <GridItem
                      xs={12}
                      sm={6}
                      md={6}
                      style={{ marginBottom: "10px" }}
                    >
                      <FormControl fullWidth>
                        <Field
                          component={AutofillV3}
                          validate={[charMin3]}
                          absolute
                          name="occupation"
                          label="Occupation"
                          checkValidation={this.state.checkValidation}
                          onChange={e => this.occupationTextChanged(e, refetch)}
                          onItemSelect={(displayText, id) =>
                            this.occupationSelected(displayText, id, refetch)
                          }
                          autoFillList={
                            !loading && data.OccupationSearch
                              ? data.OccupationSearch
                              : []
                          }
                          loading={loading}
                          listName={"Occupations"}
                          zIndex={1000}
                          displayText={"name"}
                        />
                      </FormControl>
                    </GridItem>
                  );
                }}
              </Query>
              <GridItem xs={12} sm={6} md={6} style={{ marginBottom: "10px" }}>
                <FormControl fullWidth>
                  <Field
                    component={FormDropdown}
                    checkValidation={this.state.checkValidation}
                    label="Title"
                    name="title"
                    options={[
                      {
                        value: "validationError",
                        displayValue: "Please select"
                      },
                      { value: "MR", displayValue: "MR" },
                      { value: "MRS", displayValue: "MRS" },
                      { value: "MISS", displayValue: "MISS" },
                      { value: "MS", displayValue: "MS" },
                      { value: "ADV", displayValue: "ADV" },
                      { value: "DR", displayValue: "DR" },
                      { value: "JUDG", displayValue: "JUDGE" },
                      { value: "PROF", displayValue: "PROF" }
                    ]}
                  />
                </FormControl>
              </GridItem>

              <GridItem xs={12} sm={6} md={6} style={{ marginBottom: "10px" }}>
                <FormControl fullWidth>
                  <Field
                    component={FormDropdown}
                    label="Language"
                    name="language"
                    options={[
                      {
                        value: "validationError",
                        displayValue: "Please select"
                      },
                      { value: "english", displayValue: "English" },
                      { value: "afrikaans", displayValue: "Afrikaans" }
                    ]}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={6} md={6} style={{ marginBottom: "35px" }}>
                <FormControl fullWidth>
                  <Field
                    component={FormDropdown}
                    checkValidation={this.props.checkValidation}
                    label="Smoker?"
                    name="smoker"
                    options={[
                      {
                        value: "validationError",
                        displayValue: "Please select"
                      },
                      { value: "N", displayValue: "No" },
                      { value: "Y", displayValue: "Yes" }
                    ]}
                  />
                </FormControl>
              </GridItem>

              <FromToGrid
                label="Birthday"
                from={
                  <React.Fragment>
                    <Typography>From</Typography>
                    <FormControl fullWidth>
                      <Field
                        component={DayMonth}
                        name="birthdayFrom"
                        placeholder="DD/MM"
                        checkValidation={this.state.checkValidation}
                        validate={[monthDayValid]}
                      />
                    </FormControl>
                  </React.Fragment>
                }
                to={
                  <React.Fragment>
                    <Typography>To</Typography>
                    <FormControl fullWidth>
                      <Field
                        component={DayMonth}
                        name="birthdayTo"
                        placeholder="DD/MM"
                        validate={[monthDayValid, this.birthdayToValid]}
                      />
                    </FormControl>
                  </React.Fragment>
                }
              />

              <FromToGrid
                label="Anneversary"
                from={
                  <React.Fragment>
                    <Typography>From</Typography>
                    <FormControl fullWidth>
                      <Field
                        component={DayMonth}
                        name="anneversaryFrom"
                        placeholder="DD/MM"
                        validate={[monthDayValid]}
                      />
                    </FormControl>
                  </React.Fragment>
                }
                to={
                  <React.Fragment>
                    <Typography>To</Typography>
                    <FormControl fullWidth>
                      <Field
                        component={DayMonth}
                        name="anneversaryTo"
                        placeholder="DD/MM"
                        validate={[monthDayValid, this.anneversaryToValid]}
                      />
                    </FormControl>
                  </React.Fragment>
                }
              />

              <FromToGrid
                label="Income"
                from={
                  <React.Fragment>
                    <FormControl fullWidth>
                      <Field
                        component={FormInput}
                        label="Minimum"
                        name="incomeMin"
                        checkValidation={this.state.checkValidation}
                      />
                    </FormControl>
                  </React.Fragment>
                }
                to={
                  <React.Fragment>
                    <FormControl fullWidth>
                      <Field
                        component={FormInput}
                        label="Maximum"
                        name="incomeMax"
                        validate={[this.incomeToValid]}
                        checkValidation={this.state.checkValidation}
                      />
                    </FormControl>
                  </React.Fragment>
                }
              />

              <FromToGrid
                label="Age"
                from={
                  <React.Fragment>
                    <FormControl fullWidth>
                      <Field
                        component={FormInput}
                        label="Minimum"
                        name="ageMin"
                        checkValidation={this.state.checkValidation}
                      />
                    </FormControl>
                  </React.Fragment>
                }
                to={
                  <React.Fragment>
                    <FormControl fullWidth>
                      <Field
                        component={FormInput}
                        label="Maximum"
                        name="ageMax"
                        validate={[this.ageMaxValid]}
                        checkValidation={this.state.checkValidation}
                      />
                    </FormControl>
                  </React.Fragment>
                }
              />

              {this.state.loading ? (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ textAlign: "center", margin: "40px 0px 0px" }}
                >
                  <CircularProgress color="secondary" size={30} />
                </Grid>
              ) : null}
            </Grid>
          )}
        </DialogContent>
        {this.state.loadingSubmit ? null : (
          <DialogActions>
            <Button color="primary" onClick={this.props.closeDialog}>
              Cancel
            </Button>
            <Button color="primary" onClick={this.onSubmit}>
              Search
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

SearchDialog = reduxForm({
  form: "advancedSearch",
  destroyOnUnmount: true
})(SearchDialog);

export default SearchDialog;



// WEBPACK FOOTER //
// ./src/views/Clients/components/advanced_search/SearchDialog.jsx